const MetricsGetter = {
    summary: (state) => state.summary,
    dashboard: state => state.dashboard,
    balances: state => state.balances
};

export default MetricsGetter;